export const CREATE_TESTS_ORDER = '@@hfty-order-tests/CREATE_TESTS_ORDER'
